import axios from 'axios';
import { CancelCartSessionParams, CancelCartSessionResult } from '../../../reserve';
import { useMutation, UseMutationOptions } from './useMutation';
import { useApp } from '../designs/paper/context/AppContext';

type UseCancelCartSessionOptions = UseMutationOptions<
  Awaited<CancelCartSessionResult>,
  Error,
  CancelCartSessionParams
>;

/**
 * Hook to cancel a cart session and all its reservation drafts
 * Changes status to 'cancelled' and removes checkoutUrl
 * @param options - Mutation options
 */
export function useCancelCartSession(options?: UseCancelCartSessionOptions) {
  const { config } = useApp();
  return useMutation<Awaited<CancelCartSessionResult>, Error, CancelCartSessionParams>(
    async params => {
      const response = await axios.post<CancelCartSessionResult>(
        config.cancelCartSessionUrl,
        params
      );
      return response.data;
    },
    options
  );
}
